/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free RSCU calculator. Paste a coding sequence to get the Relative Synonymous Codon Usage of each codon — values above 1 are over-represented, below 1 under-represented.`)
};

const es_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de RSCU. Pega una secuencia codificante para obtener el Uso Relativo de Codones Sinónimos de cada codón — valores superiores a 1 están sobrerrepresentados, inferiores a 1 subrepresentados.`)
};

const de_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser RSCU-Rechner. Fügen Sie eine Kodierungssequenz ein, um die Relative Synonyme Codon-Nutzung jedes Codons zu erhalten — Werte über 1 sind überrepräsentiert, unter 1 unterrepräsentiert.`)
};

const nl_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis RSCU-calculator. Plak een coderende sequentie om de Relative Synonymous Codon Usage van elk codon te krijgen — waarden boven 1 zijn oververtegenwoordigd, onder 1 ondervertegenwoordigd.`)
};

const fr_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit RSCU. Collez une séquence codante pour obtenir l'usage relatif des codons synonymes de chaque codon — les valeurs supérieures à 1 sont surreprésentées, inférieures à 1 sous-représentées.`)
};

const it_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito RSCU. Incolla una sequenza codificante per ottenere l'uso relativo dei codoni sinonimi di ciascun codone — valori sopra 1 sono sovra-rappresentati, sotto 1 sotto-rappresentati.`)
};

const pt_br2_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de RSCU. Cole uma sequência codificante para obter o Uso Relativo de Códons Sinônimos de cada códon — valores acima de 1 são super-representados, abaixo de 1 são sub-representados.`)
};

const pt_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de RSCU. Cole uma sequência codificante para obter o Uso Relativo de Codões Sinónimos de cada codão — valores acima de 1 estão sobrerrepresentados, abaixo de 1 estão subrrepresentados.`)
};

const ja_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のRSCU計算ツール。コード配列を貼り付けると、各コドンの相対同義コドン使用頻度が得られます — 1を超える値は過剰使用、1未満は過小使用を示します。`)
};

const zh_rscu_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 RSCU 计算器。粘贴编码序列即可获得每个密码子的相对同义密码子使用度——高于 1 表示过度使用，低于 1 表示使用不足。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_meta_description", locale)
	if (locale === "en") return en_rscu_meta_description(inputs)
	if (locale === "es") return es_rscu_meta_description(inputs)
	if (locale === "de") return de_rscu_meta_description(inputs)
	if (locale === "nl") return nl_rscu_meta_description(inputs)
	if (locale === "fr") return fr_rscu_meta_description(inputs)
	if (locale === "it") return it_rscu_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_meta_description(inputs)
	if (locale === "pt") return pt_rscu_meta_description(inputs)
	if (locale === "ja") return ja_rscu_meta_description(inputs)
	return zh_rscu_meta_description(inputs)
};